module.exports = __webpack_public_path__ + "static/theme-editor-search-in-category-120e16d943b236473709a48b4ecb2370.png";